import { ModuleBase } from "@/modules/base"
import { Component, Mixins } from 'vue-property-decorator'
import BaseLayer from "./BaseLayer.vue"
import { defaultParams } from "./defaultParams"
import Window from './Window.vue'
import WindowMenu from "./WindowMenu.vue"

export const envName = process.env.VUE_APP_DATASET as string


@Component
export class PrettyPictureLayerModule extends Mixins(ModuleBase) {
  frameStore() {
    const params = defaultParams()
    const paramsWindow = record(params, (k) => ({ isOpen: false }))
    return {
      show: envName !== 'hscla',
      params,
      paramsWindow,
    }
  }

  get outlet() {
    return {
      window: Window,
      baseLayer: BaseLayer,
      analysisMenu: WindowMenu,
    }
  }
}

function record<T, U>(base: T, cb: (k: string) => U): Record<keyof T, U> {
  const d = {} as any
  for (const k of Object.keys(base)) {
    d[k] = cb(k)
  }
  return d
}
